// import { BASE_URLS, getCurrentBaseURL } from "./api";
// const baseURL = getCurrentBaseURL();
// const uploadImageToS3 = async (file, path) => {
//     console.log(file, path,"45456465");
    
//     try {
//         // Create form data
//         const formData = new FormData();
//         formData.append("file", file);
//         formData.append("file_path", path);

//         // Get user token from wherever it's stored in your application
//         const userToken = localStorage.getItem('userToken'); // Adjust according to how you store the token

//         // Set up request options with headers
//         const options = {
//             method: "POST",
//             headers: {
//                 'Authorization': userToken
//             },
//             body: formData
//         };

//         // Make direct API call
//         const response = await fetch(`${baseURL}/admin/upload-media`, options);
        
//         if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || `Request failed with status ${response.status}`);
//         }

//         const result = await response.json();
//         console.log(result, "result");
        
//         // Return the media URL from the response
//         return result.data.media_url;
//     } catch (error) {
//         console.error("Upload Error:", error);
//         throw error;
//     }
// };

// export default uploadImageToS3;

import { getCurrentBaseURL } from "./api";

const MAX_FILE_SIZE = 4 * 1024 * 1024; // 4MB in bytes

const uploadImageToS3 = async (file, path) => {
    console.log(file, path, "45456465");
    
    try {
        // Validate file size before proceeding
        if (file.size > MAX_FILE_SIZE) {
            throw new Error("File size exceeds the maximum limit of 4MB.");
        }

        // Create form data
        const formData = new FormData();
        formData.append("file", file);
        formData.append("file_path", path);

        // Get user token from wherever it's stored in your application
        const userToken = localStorage.getItem('userToken'); // Adjust according to how you store the token

        // Set up request options with headers
        const options = {
            method: "POST",
            headers: {
                'Authorization': userToken
            },
            body: formData
        };

        // Make direct API call
        const response = await fetch(`${getCurrentBaseURL()}/admin/upload-media`, options);
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `Request failed with status ${response.status}`);
        }

        const result = await response.json();
        console.log(result, "result");
        
        // Return the media URL from the response
        return result.data.media_url;
    } catch (error) {
        console.error("Upload Error:", error);
        throw error;
    }
};

export default uploadImageToS3;